// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_grid-row-2__ruCTb {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.Button_vm-20__TCCev {
  margin: 20px 0;
}

.Button_divider-0__WzNO9 {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.Button_rel__p2Ab8 {
  position: relative;
}

.Button_flex__59ozf {
  display: flex;
}

.Button_jcc__QyIPu {
  justify-content: center !important;
}

.Button_button__sBx4u {
  background-color: #21ba72;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-user-select: none;
  user-select: none;
  border: none;
  justify-content: center;
}
.Button_button__sBx4u:disabled {
  cursor: default;
}
.Button_button_gradient__5OyBs {
  background: linear-gradient(56.46deg, #a4eedc -45.58%, #5bcab5 19.1%, #6baae4 100%);
}
.Button_button_gradientDanger__l6NER {
  background: linear-gradient(94.6deg, #FEA4A4 0.09%, #EE6767 100.09%);
}
.Button_button_gradientOrange__7AEZW {
  background: linear-gradient(91.58deg, #FFB973 0.03%, #FFA244 100.03%);
}
.Button_button_gradientLight__fmFmD {
  background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);
  opacity: 0.3;
  justify-content: center;
}
.Button_button_danger__rD4Ls {
  color: #EC1B28;
}
.Button_button_black__zEu8G {
  color: #000000;
}
.Button_button_primary__h2QWa {
  color: #00809C;
}
.Button_button_s__sf2he {
  font-size: 12px;
  font-weight: 400;
  line-height: 26px;
}
.Button_button_small__N\\+Bi5 {
  border-radius: 32px;
  padding: 4px 18px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}
.Button_button_sm__lu59U {
  font-size: 14px;
  font-weight: 400;
}
.Button_button_medium__UnvFP {
  border-radius: 32px;
  padding: 8px 32px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}
.Button_button_large__YBadY {
  border-radius: 32px;
  padding: 8px 32px;
}
.Button_button_withoutBackground__pCHNV {
  background: none;
  color: #000000;
  padding: 8px 32px;
  border: 1px solid #c4c4c4;
}
.Button_button_inactive__RHnJQ {
  opacity: 0.3;
}
.Button_button_service__yiyJd {
  padding: 0;
  border: 1px solid transparent;
  background: none;
}
.Button_button_fullWidth__g8Ogk {
  width: 100%;
}
.Button_button_hover__E7euT:hover {
  background: linear-gradient(56.46deg, #a4eedc -45.58%, #5bcab5 19.1%, #6baae4 100%);
  color: #ffffff;
}

.Button_icon__ybmV2 {
  margin-right: 8px;
  display: flex;
  align-items: center;
}

.Button_prefixIcon__L7L0L {
  margin-left: 22px;
}

.Button_button_circle__0jZF3 {
  padding: unset;
  width: 40px;
  height: 40px;
}
.Button_button_circle__0jZF3 .Button_icon__ybmV2 {
  margin: unset;
}`, "",{"version":3,"sources":["webpack://./src/assets/helpers/grid.scss","webpack://./src/components/ui/Button/Button.module.scss","webpack://./src/assets/helpers/colors.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;ACAF;;ADIA;EACE,cAAA;ACDF;;ADKA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADQR;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kCAAA;ACHF;;AAvBA;EACE,yBC2BM;ED1BN,cCJM;EDKN,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,YAAA;EACA,uBAAA;AA0BF;AAxBE;EACE,eAAA;AA0BJ;AAtBE;EACE,mFCyBc;ADDlB;AArBE;EACE,oEC8Ca;ADvBjB;AApBE;EACE,qEC2Ca;ADrBjB;AAnBE;EACE,mFCmBY;EDlBZ,YAAA;EACA,uBAAA;AAqBJ;AAlBE;EACE,cCEG;ADkBP;AAjBE;EACE,cCjBI;ADoCR;AAhBE;EACE,cCXM;AD6BV;AAdE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAgBJ;AAbE;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAeJ;AAZE;EACE,eAAA;EACA,gBAAA;AAcJ;AAXE;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAaJ;AAVE;EACE,mBAAA;EACA,iBAAA;AAYJ;AARE;EACE,gBAAA;EACA,cC5DI;ED6DJ,iBAAA;EACA,yBAAA;AAUJ;AAPE;EACE,YAAA;AASJ;AANE;EACE,UAAA;EACA,6BAAA;EACA,gBAAA;AAQJ;AAJE;EACE,WAAA;AAMJ;AAAI;EACE,mFChEY;EDiEZ,cC/GE;ADiHR;;AAGA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAAF;AAEE;EACE,aAAA;AAAJ","sourcesContent":["// grid\n.grid-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n// paddings, margins\n.vm-20 {\n  margin: 20px 0;\n}\n\n// elements\n.divider-0 {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n}\n\n// helpers\n.rel {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.jcc {\n  justify-content: center!important;\n}","@import '../../../assets/helpers/index.scss';\n\n// basic\n.button {\n  background-color: $primary;\n  color: $white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  -webkit-user-select: none;  \n  -moz-user-select: none;    \n  -ms-user-select: none;      \n  user-select: none;\n  border: none;\n  justify-content: center;\n\n  &:disabled {\n    cursor: default;\n  }\n\n  // color settings\n  &_gradient {\n    background: $defaultGradient;\n  }\n\n  &_gradientDanger {\n    background: $mainBtnDanger;\n  }\n\n  &_gradientOrange {\n    background: $gradientOrange;\n  }\n\n  &_gradientLight {\n    background: $gradientLight;\n    opacity: 0.3;\n    justify-content: center;\n  }\n\n  &_danger {\n    color: $serviceDanger;\n  }\n\n  &_black {\n    color: $black;\n  }\n\n  &_primary {\n    color: $action;\n  }\n\n  //  size settings\n  &_s {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 26px;\n  }\n\n  &_small {\n    border-radius: 32px;\n    padding: 4px 18px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n  }\n\n  &_sm {\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  &_medium {\n    border-radius: 32px;\n    padding: 8px 32px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n  }\n\n  &_large {\n    border-radius: 32px;\n    padding: 8px 32px;\n  }\n\n  //  display settings\n  &_withoutBackground {\n    background: none;\n    color: $black;\n    padding: 8px 32px;\n    border: 1px solid $gray3;\n  }\n\n  &_inactive {\n    opacity: .3;\n  }\n\n  &_service {\n    padding: 0;\n    border: 1px solid transparent;\n    background: none;\n  }\n\n  // positioning settings\n  &_fullWidth {\n    width: 100%;\n  }\n\n  &_hover {\n    //transition: all 0.3s ease-in-out;\n\n    &:hover {\n      background: $defaultGradient;\n      color: $white;\n    }\n  }\n}\n\n.icon {\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.prefixIcon{\n  margin-left: 22px;\n}\n\n.button_circle {\n  padding: unset;\n  width: 40px;\n  height: 40px;\n\n  .icon {\n    margin: unset;\n  }\n}\n","//  Color scheme\n$white: #ffffff;\n$whiteGray: #f2f4f7;\n$halfGray: #f5faff;\n$grayWhite: #e7e9eb;\n$gray2: #e9eaea;\n$gray5: #d0d7dd;\n$gray7: #d1d5df;\n$gray8: #f4f4f4;\n$gray13: #f8f9fa;\n$gray12: #e0e1e9;\n$gray9: #cbcdd0;\n$gray10: #E1E5EA;\n$gray11: #1F1F22;\n$shadowGray: #d5d5d6;\n$shadowGray2: rgba(25, 27, 35, 0.15);\n$gray3: #c4c4c4;\n$lightGray: #aab1ba;\n$gray4: #878b90;\n$gray6: #7d838a;\n$gray14: #F6F6F6;\n$grayAsphalt: #344045;\n$gray: #808185;\n$textGray: #000000;\n$black1: #0b1f33;\n$black2: #333F48;\n\n$black: #000000;\n\n$lightGreen: #a4eedc;\n$green3: #5dc8ba;\n$green: #21ba72;\n$green0: #30BA9A;\n$green0-0_5: rgba(48, 186, 154, 0.50);\n$green4: #62BDCA;\n$darkGreen: #209f6d;\n$green2: #21a19a;\n$prGreen: #00809C;\n$lightBlue: #d8ebfe;\n$blue: #1358bf;\n$red: #ee505a;\n$red0_5: rgba(238, 80, 90, 0.5);\n$red1: #EC1B28;\n$beige: rgba(255, 205, 156, 0.6);\n$yellow: #FFE5CD;\n\n// gradients\n$defaultGradient: linear-gradient(\n                56.46deg,\n                #a4eedc -45.58%,\n                #5bcab5 19.1%,\n                #6baae4 100%\n);\n$gradientLight: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n$gradient2: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.4) 0%,\n                rgba(212, 248, 239, 0.4) 49.63%,\n                rgba(199, 247, 233, 0.4) 100%\n);\n$gradient3: linear-gradient(225deg, #eef181 0%, #92dd90 51.47%, #4de9cb 100%);\n$gradient4: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.3) 0%,\n                rgba(212, 248, 239, 0.3) 49.63%,\n                rgba(199, 247, 233, 0.3) 100%\n);\n$gradient5: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradient6: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradientPlaceholder: linear-gradient(90deg, rgba(255,255,255,0) -10%, rgba(255,255,255,1) 50%);\n$gradientPlaceholderDisabled: linear-gradient(90deg, rgb(163 224 219 / 18%) -10%, rgb(233 234 234) 50%);\n$boxShadowModal: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n$gradientDanger: linear-gradient(94.6deg, #FEA4A4 0.09%, #EE6767 100.09%);\n$gradientOrange: linear-gradient(91.58deg, #FFB973 0.03%, #FFA244 100.03%);\n$mainPageBackground: linear-gradient(180deg, rgba(255, 255, 255, 0) 61.86%, rgba(255, 255, 255, 0.8) 100%), radial-gradient(10.51% 41.68% at 32.4% 13.32%, rgba(33, 186, 114, 0.36) 0%, rgba(33, 186, 114, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(33.57% 117.61% at 63.33% -9.67%, rgba(90, 177, 255, 0.24) 0%, rgba(0, 135, 205, 0.24) 0.01%, rgba(0, 135, 205, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(19.56% 68.52% at -4.53% 77.65%, rgba(255, 224, 102, 0.3) 0%, rgba(255, 224, 102, 0) 100%), linear-gradient(90deg, rgba(66, 227, 180, 0.34) 0%, rgba(107, 234, 199, 0.34) 49.98%, rgba(155, 208, 254, 0.34) 100%), #FFFFFF;\n//  color vars\n$borderOpacityColor: rgba(214, 214, 215, 0.5);\n$boxShadowColor: rgba(0, 0, 0, 0.08);\n$footerColor: #f8fefc;\n$nonActiveText: $gray9;\n\n$primary: $green;\n$main: $white;\n$scrollBg: $halfGray;\n$scroll: $gray7;\n$scrollHover: $shadowGray;\n$editorMenuHover: $halfGray;\n$border: $gray5;\n\n$mainText: $black;\n$headText: $textGray;\n$smallText: $gray6;\n$tableSmallText: $gray4;\n$blockTitle: $black1;\n$calendarGradient: $gradient5;\n$chartActiveBg: $gradient3;\n$nonActiveElement: $gray8;\n\n$secondaryColor: $lightGray;\n$borderColor: $grayWhite;\n$tooltipBorder: $gray12;\n$tooltipShadow: $shadowGray2;\n$danger: $red;\n$serviceDanger: $red1;\n$mainBtnDanger: $gradientDanger;\n$action: $prGreen;\n$bgAction: lighten($lightGreen, 15%);\n$inputBorderColor: $shadowGray;\n$selectBorderColor: $gray10;\n$documentButton: $gray2;\n$tagBackground: $whiteGray;\n$cardShadow: $boxShadowModal;\n$textSelected: $lightBlue;\n$menuHover: $gradient5;\n$blockBg: $gray13;\n$toggleBg: $gradientLight;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid-row-2": `Button_grid-row-2__ruCTb`,
	"vm-20": `Button_vm-20__TCCev`,
	"divider-0": `Button_divider-0__WzNO9`,
	"rel": `Button_rel__p2Ab8`,
	"flex": `Button_flex__59ozf`,
	"jcc": `Button_jcc__QyIPu`,
	"button": `Button_button__sBx4u`,
	"button_gradient": `Button_button_gradient__5OyBs`,
	"button_gradientDanger": `Button_button_gradientDanger__l6NER`,
	"button_gradientOrange": `Button_button_gradientOrange__7AEZW`,
	"button_gradientLight": `Button_button_gradientLight__fmFmD`,
	"button_danger": `Button_button_danger__rD4Ls`,
	"button_black": `Button_button_black__zEu8G`,
	"button_primary": `Button_button_primary__h2QWa`,
	"button_s": `Button_button_s__sf2he`,
	"button_small": `Button_button_small__N+Bi5`,
	"button_sm": `Button_button_sm__lu59U`,
	"button_medium": `Button_button_medium__UnvFP`,
	"button_large": `Button_button_large__YBadY`,
	"button_withoutBackground": `Button_button_withoutBackground__pCHNV`,
	"button_inactive": `Button_button_inactive__RHnJQ`,
	"button_service": `Button_button_service__yiyJd`,
	"button_fullWidth": `Button_button_fullWidth__g8Ogk`,
	"button_hover": `Button_button_hover__E7euT`,
	"icon": `Button_icon__ybmV2`,
	"prefixIcon": `Button_prefixIcon__L7L0L`,
	"button_circle": `Button_button_circle__0jZF3`
};
export default ___CSS_LOADER_EXPORT___;
